export default __webpack_public_path__ + "static/media/kitchen4-afterB-768w.87bc02cd.webp";